import cx from "classnames"

import type { CheckboxLabelFontSize, CheckboxVariant } from "./types"

import styles from "./index.module.css"
import { CHECKBOX_LABEL_FONT_SIZE, CHECKBOX_VARIANT, CHECKBOX_LABEL_TEXT_COLOR } from "./types"

const CHECKBOX_VARIANT_TO_CLASS = {
  [CHECKBOX_VARIANT.info]: styles["color-info"],
  [CHECKBOX_VARIANT.success]: styles["color-success"],
  [CHECKBOX_VARIANT.warning]: styles["color-warning"],
  [CHECKBOX_VARIANT.error]: styles["color-error"],
  [CHECKBOX_VARIANT.default]: styles["color-default"],
} as const

const CHECKBOX_LABEL_FONT_SIZE_TO_CLASS = {
  [CHECKBOX_LABEL_FONT_SIZE.xs]: styles["font-size-xs"],
  [CHECKBOX_LABEL_FONT_SIZE.s]: styles["font-size-s"],
  [CHECKBOX_LABEL_FONT_SIZE.m]: styles["font-size-m"],
  [CHECKBOX_LABEL_FONT_SIZE.l]: styles["font-size-l"],
} as const

const CHECKBOX_LABEL_TEXT_COLOR_TO_CLASS = {
  [CHECKBOX_LABEL_TEXT_COLOR.info]: styles["color-info"],
  [CHECKBOX_LABEL_TEXT_COLOR.success]: styles["color-success"],
  [CHECKBOX_LABEL_TEXT_COLOR.warning]: styles["color-warning"],
  [CHECKBOX_LABEL_TEXT_COLOR.error]: styles["color-error"],
  [CHECKBOX_LABEL_TEXT_COLOR.default]: styles["color-highlighted"],
} as const

export type CheckboxProps = Omit<React.ComponentPropsWithRef<"input">, "type" | "className"> & {
  variant?: CheckboxVariant
  label?: React.ReactNode
  fontSize?: CheckboxLabelFontSize
}

export const Checkbox = ({
  ref,
  label,
  variant = CHECKBOX_VARIANT.default,
  fontSize = CHECKBOX_LABEL_FONT_SIZE.m,
  ...htmlProps
}: CheckboxProps) => {
  const checkboxClasses = cx(styles.checkbox, CHECKBOX_VARIANT_TO_CLASS[variant])
  const labelClasses = cx(
    styles.label,
    CHECKBOX_VARIANT_TO_CLASS[variant],
    CHECKBOX_LABEL_FONT_SIZE_TO_CLASS[fontSize],
    CHECKBOX_LABEL_TEXT_COLOR_TO_CLASS[variant],
  )
  return (
    <label htmlFor={htmlProps.id} className={labelClasses}>
      <div className={styles.checkboxContainer}>
        <input ref={ref} type="checkbox" className={checkboxClasses} {...htmlProps} />
      </div>
      {label}
    </label>
  )
}

Checkbox.displayName = "Checkbox"

export { CHECKBOX_VARIANT, CHECKBOX_LABEL_FONT_SIZE, CHECKBOX_LABEL_TEXT_COLOR }
